import React, { forwardRef } from 'react'
import { helpers } from '@linqpal/common-frontend'
import { withEditableConverter } from '@linqpal/common-frontend/src/hooks'
import { AppInputBase } from '@linqpal/common-frontend/src/ui'

const { composeStyle } = helpers

/**
 * Masked input with Big and Small Sizes
 *
 * @param props
 * @param props.style
 * @param props.nativeProps
 * @param props.big
 * @param props.half
 * @returns {JSX.Element}
 * @constructor
 */
export const BigSmallMaskedInputBase = forwardRef(({
  style = {},
  nativeProps,
  big = false,
  half = false,
  ...props
}, ref) => <AppInputBase style={composeStyle(big && { height: 72 }, half && { width: 144 }, style)}
                         innerBorderStyle={composeStyle(big && { marginTop: 8 }, half && {
                           width: 100,
                           paddingLeft: 16
                         })} ref={ref} {...props} />)

export const BigSmallMaskedInput = withEditableConverter(BigSmallMaskedInputBase)
